<script lang="ts">
    import CN from "classnames";

    import BaseButton from "./BaseButton.svelte";

    export let big = false;
    export let className: string;
    export let ariaLabel: string | undefined = undefined;
    export let disabled = false;
    export { className as class };

    $: classes = CN("gw-btn-with-icon", className, {
        "gw-btn-with-icon--big": big,
    });
</script>

<BaseButton on:click type="button" class={classes} {ariaLabel} {disabled}>
    <slot />
</BaseButton>

<style lang="postcss">
    :global(.gw-btn-with-icon) {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 1.7em;
        height: 1.7em;
        border: none;
        background-color: transparent;
        cursor: pointer;
        border-radius: 3px;
        transition: background-color 0.3s ease;
    }
    :global(.gw-btn-with-icon.gw-btn-with-icon--big) {
        width: 2em;
        height: 2em;
    }
    :global(.gw-btn-with-icon:hover) {
        background-color: rgba(204, 204, 204, 0.3);
    }
</style>
